<template>
    <div class="d-flex justify-content-between align-items-center" style="height: 58px; background-color: #F1F1F1E5;">
        <div>
            <span class="ms-5" style="font-size: 16px; cursor: pointer;">Правила работы с САЗ «МАРС»</span>
            <!-- <div class="d-flex align-items-center">
                <button class="btn btn-secondary lh-1"
                    style="width: 169px; height: 28px; font-size: 14px; border-radius: 5px !important;">
                    Центр поддержки
                </button>
            </div> -->
        </div>
        <div class="text-decoration-none justify-content-center align-items-center header-nav d-flex gap-4"
             style="text-align: center; min-width: 250px;">
          <a style="font-weight: 500; font-size: 18px;"
             href="tel:83452574500">
            8 (3452) 57-45-00
          </a>
          <a style="font-weight: 500; font-size: 18px;"
             href="tel:88007002582">
            8 (800) 700-25-82
          </a>
          <a style="font-weight: 300; font-size: 18px;"
             href="mailto:info@etp-mir.ru">
            info@etp-mir.ru
          </a>
        </div>
        <div class="me-5">
          <a href="https://etp-mir.ru/" target="_blank">
            <img src="/mir.png" alt="Logo" class="me-3" style="width: 40px;">
          </a>
          <a href="https://uris72.ru/" target="_blank">
            <img src="/yuris.png" alt="Logo" class="" style="width: 97px;">
          </a>
        </div>
    </div>
</template>
<script setup lang="ts">
</script>